import _ from 'lodash'
import { fontFaceDefinitions, madeforFontFamilies } from '@wix/fonts-data'
import { patchFontDisplay } from './fontsParser'
import { FontLoadStrategy } from '@wix/thunderbolt-becky-types'

export const getMadeforFontFamillies = () => madeforFontFamilies
const DEFAULT_FONT_DISPLAY = 'block'
type FontFacesMap = Record<string, Array<string>>

const fontFacesMap_byFontDisplay: Partial<Record<FontLoadStrategy, FontFacesMap>> = { block: fontFaceDefinitions }

const CONSTANTS = {
	UPLOADED_FONT_PREFIX: 'wf_',
	LONG_UPLOADED_FONT_PREFIX: 'wfont_',
}

const UPLOADED_FONT_MASK = 'wfont_[0-9a-f]{6}_[0-9a-f]{32}'
const UPLOADED_FONT_TEST = new RegExp(`^${UPLOADED_FONT_MASK}`)

export function isUploadedFontFamily(fontFamilyStr: string) {
	if (_.isNil(fontFamilyStr) || _.isEmpty(fontFamilyStr)) {
		return false
	}

	const fontName = _.head(fontFamilyStr.split(','))!
	return UPLOADED_FONT_TEST.test(fontName)
}

function getShortUploadedFontFamily(font: string) {
	const newLocal = /^wfont_[0-9a-f]{6}_([0-9a-f]{25})[0-9a-f]{7}/.exec(font)!
	return `wf_${newLocal[1]}`
}

function getUploadedId(uploadedFonStr: string) {
	return uploadedFonStr.replace(CONSTANTS.LONG_UPLOADED_FONT_PREFIX, '').trim()
}

function getFontName(font: string) {
	return _.head(font.split(',')) || ''
}

function resolveMediaRootUrl(mediaRootUrl: string): string {
	return mediaRootUrl.replace(/(https?:\/\/)|^/, 'https://').replace(/\/$|$/, '/')
}

function getFontUrl(mediaRootUrl: string, fontId: string, type: string) {
	return `${mediaRootUrl}ufonts/${fontId}/${type}/file.${type}`
}

function getSrcUrl(mediaRootUrl: string, fontId: string, type: string) {
	return `url("${getFontUrl(mediaRootUrl, fontId, type)}") format("${type}")`
}

function getUploadFontFace(font: string, mediaRootUrl: string, fontDisplay: string) {
	const fontName = getFontName(font)
	const fontId = getUploadedId(fontName)
	const shortFontName = getShortUploadedFontFamily(fontName)
	return `@font-face {
font-display: ${fontDisplay};
font-family: ${shortFontName};
src: ${getSrcUrl(mediaRootUrl, fontId, 'woff2')},
${getSrcUrl(mediaRootUrl, fontId, 'woff')},
${getSrcUrl(mediaRootUrl, fontId, 'ttf')};
}`
}

export const getFontFacesCss = (
	fontFamilies: Array<string>,
	mediaRootUrl: string,
	fontDisplay: FontLoadStrategy = DEFAULT_FONT_DISPLAY
): string => {
	const fontFacesCssMap = (fontFacesMap_byFontDisplay[fontDisplay] =
		fontFacesMap_byFontDisplay[fontDisplay] || patchFontDisplay(fontDisplay, fontFaceDefinitions))

	mediaRootUrl = resolveMediaRootUrl(mediaRootUrl)
	const fonts = fontFamilies.reduce<Array<string>>((resultArray, fontFamily) => {
		const isUploadedFont = isUploadedFontFamily(fontFamily)
		const fontFaces = isUploadedFont
			? getUploadFontFace(fontFamily, mediaRootUrl, fontDisplay)
			: fontFacesCssMap[fontFamily.toLowerCase()]
		return resultArray.concat(fontFaces)
	}, [])
	const fontsCss = _.compact(fonts).join('\n')
	return fontsCss
}

export interface IDetermineFontFacesDisplayParams {
	isEditor: boolean
	siteFontDisplay: FontLoadStrategy | undefined | null
}

export function determineFontFacesFontDisplay({
	siteFontDisplay,
	isEditor,
}: IDetermineFontFacesDisplayParams): FontLoadStrategy {
	if (isEditor) {
		// in order to hasPendingFonts ViewerAPI to work as expected, the font display should be block
		return 'block'
	}

	if (siteFontDisplay) {
		return siteFontDisplay
	}

	return 'swap'
}
